import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { fetchFacturesForDossier } from "../../data/slices/facturesDossierSlice";
import { Box, Button, Typography, IconButton, Tooltip } from "@mui/material";
import { useEffect } from "react";
import { COLORS } from "../../settings/themeSettings";
import StyledTable from "../../components/table-component/StyledTable";
import { Delete } from "@mui/icons-material";
import facturationService from "../../services/facturationService";
import { notify } from "../../settings/toastSetting";

const FacturesDossierPage = (props) => {
    const { id, type } = useParams();

    const navigateTo = useNavigate();
    const onOptionClicked = (_id) => {
        navigateTo(`/dossiers/${type}/${id}/factures/${_id}`);
    }

    const onRowDoubleClick = (_id) => {
        navigateTo(`/dossiers/${type}/${id}/factures/${_id}/edit`);
    }

    const handleDeleteFacture = async (factureId) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cette facture ?")) {
            try {
                await facturationService.deleteFacture(factureId);
                notify("Facture supprimée", "success");
                dispatch(fetchFacturesForDossier(id));
            } catch (err) {
                notify("Erreur lors de la suppression", "error");
            }
        }
    }

    const { factures, factureFetchStatus } = useSelector((state) => state.facturesDossier);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchFacturesForDossier(id));
    }, [id, dispatch]);




    return (<div className="circuit-page">
        <div className="header">
            <div className="title">
                Liste des factures
            </div>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => { navigateTo(`/facturation/nouvelle/dossier/${type}/${id}`) }}
                >
                    Nouvelle Factures
                </Button>
            </Box>
        </div>
        {
            factureFetchStatus === 'loading' ?
                <div className="loader-container">
                    <span className="loader"></span>
                </div>
                :

                <StyledTable
                    rows={factures}
                    head={['date', 'numero', 'commentaire', 'etat', 'actions']}
                    onOptionClicked={onOptionClicked}
                    onRowDoubleClick={onRowDoubleClick}
                    headLabels={{ 'numero': 'N° facture' }}
                    customRenderers={{
                        'numero': (value, row) => (
                            <Typography
                                component="span"
                                sx={{ color: COLORS.primary, cursor: 'pointer', textDecoration: 'underline', fontWeight: 'bold' }}
                                onClick={(e) => { e.stopPropagation(); onOptionClicked(row.id); }}
                            >
                                {value}
                            </Typography>
                        ),
                        'actions': (value, row) => (
                            <Tooltip title="Supprimer la facture">
                                <IconButton 
                                    size="small" 
                                    color="error"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteFacture(row.id);
                                    }}
                                >
                                    <Delete fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        )
                    }}
                />

            //   <UpdatedTable rows={circuits} head={['programme', 'toClient', 'methodePaiement', 'numeroFacture', 'Statut']} ></UpdatedTable>

        }

    </div>);
}


export default FacturesDossierPage;
